<div class="card">
    <div class="cardTitle">
        <h2>{{ 'dashboard.scheduledReports.sftpSettings.title' | translate }}</h2>
    </div>

    <div class="cardContent">
        <form [formGroup]="form">
            <div class="inputGroup">
                <label for="sftpSiteName">{{ 'dashboard.scheduledReports.sftpSettings.siteName.label' | translate }}</label>
                <div class="inputWrapper">
                    <app-form-error
                        [parentForm]="form"
                        [controlPath]="'sftpSiteName'"
                        [controlLabel]="'dashboard.scheduledReports.sftpSettings.siteName.label'"
                        [errorMessageOverrides]="{
                            duplicate: { errorKey: 'dashboard.scheduledReports.sftpSettings.siteName.duplicate' },
                        }"
                    />
                    <app-multi-input-control
                        [formControlName]="'sftpSiteName'"
                        [optionsList]="sftpSites"
                        [idKey]="'sftpSettingId'"
                        [labelKey]="'siteName'"
                        [id]="'sftpSiteName'"
                        [maximumSelections]="1"
                        (changeFull)="onSftpSiteNameChange($event)"
                    />
                </div>
            </div>

            <div class="inputGroup">
                <label for="host">{{ 'dashboard.scheduledReports.sftpSettings.host.label' | translate }}</label>
                <div class="inputWrapper">
                    <app-form-error
                        [parentForm]="form"
                        [controlPath]="'host'"
                        [controlLabel]="'dashboard.scheduledReports.sftpSettings.host.label'"
                    />
                    <input type="text" id="host" formControlName="host" (change)="onDetailsChange($event)" />
                </div>
                <div class="inputWrapper portContainer">
                    <app-form-error
                        [parentForm]="form"
                        [controlPath]="'port'"
                        [controlLabel]="'dashboard.scheduledReports.sftpSettings.port.label'"
                    />
                    <input
                        type="number"
                        min="21"
                        max="22"
                        step="1"
                        id="port"
                        formControlName="port"
                        placeholder="{{ 'dashboard.scheduledReports.sftpSettings.port.placeholder' | translate }}"
                        (change)="onDetailsChange($event)"
                    />
                </div>
            </div>

            <div class="inputGroup">
                <label for="loginType">{{ 'dashboard.scheduledReports.sftpSettings.loginType.label' | translate }}</label>
                <div class="inputWrapper">
                    <app-form-error
                        [parentForm]="form"
                        [controlPath]="'loginType'"
                        [controlLabel]="'dashboard.scheduledReports.sftpSettings.loginType.label'"
                    />
                    <select id="loginType" formControlName="loginType" (change)="onLoginTypeChange(); onDetailsChange($event)">
                        <option [value]="ScheduledReportLoginType.PASSWORD">
                            {{ 'dashboard.scheduledReports.sftpSettings.loginType.usernamePassword' | translate }}
                        </option>
                        <option [value]="ScheduledReportLoginType.KEY">
                            {{ 'dashboard.scheduledReports.sftpSettings.loginType.usernameKey' | translate }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="inputGroup">
                <label for="username">{{ 'dashboard.scheduledReports.sftpSettings.username.label' | translate }}</label>
                <div class="inputWrapper">
                    <app-form-error
                        [parentForm]="form"
                        [controlPath]="'username'"
                        [controlLabel]="'dashboard.scheduledReports.sftpSettings.username.label'"
                    />
                    <input type="text" id="username" formControlName="username" (change)="onDetailsChange($event)" />
                </div>
            </div>

            <div class="inputGroup" *ifNotDisabled="'password'">
                <label for="password">{{ 'dashboard.scheduledReports.sftpSettings.password.label' | translate }}</label>
                <div class="inputWrapper">
                    <app-form-error
                        [parentForm]="form"
                        [controlPath]="'password'"
                        [controlLabel]="'dashboard.scheduledReports.sftpSettings.password.label'"
                    />
                    <input
                        type="password"
                        id="password"
                        formControlName="password"
                        autocomplete="new-password"
                        (change)="onDetailsChange($event)"
                    />
                </div>
            </div>

            <div class="inputGroup" *ifNotDisabled="'key'">
                <label for="key">{{ 'dashboard.scheduledReports.sftpSettings.key.label' | translate }}</label>
                <div class="inputWrapper">
                    <app-form-error
                        [parentForm]="form"
                        [controlPath]="'key'"
                        [controlLabel]="'dashboard.scheduledReports.sftpSettings.key.label'"
                    />
                    <textarea id="key" formControlName="key" (change)="onDetailsChange($event)"></textarea>
                </div>
            </div>
        </form>
    </div>

    <div class="cardFooter">
        <button type="submit" class="button primary" (click)="saveSftpSettings()">
            {{ 'generalKeywords.confirm' | translate }}
        </button>
        <button type="button" class="button" (click)="closeModal()">
            {{ 'generalKeywords.cancel' | translate }}
        </button>
        <button type="submit" class="button default testButton" (click)="testSftpSettings()">
            {{ 'generalKeywords.test' | translate }}
        </button>
        <app-loader [matchSome]="['listingApi/graphql']" type="overlayAndSpinner" overlayType="light" />
    </div>
</div>
